var _rect, _path, _rect2, _path2, _path3, _path4, _rect3, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomnavMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 28.56,
    y: 32.24,
    width: 96.01,
    height: 96.01,
    rx: 13.72,
    ry: 13.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M110.85,128.25H42.27c-7.56,0-13.72-6.15-13.72-13.72V45.95c0-7.56,6.15-13.72,13.72-13.72H110.85c7.56,0,13.72,6.15,13.72,13.72V114.54c0,7.56-6.15,13.72-13.72,13.72ZM42.27,39.1c-3.78,0-6.86,3.08-6.86,6.86V114.54c0,3.78,3.07,6.86,6.86,6.86H110.85c3.78,0,6.86-3.08,6.86-6.86V45.95c0-3.78-3.07-6.86-6.86-6.86H42.27Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 131.43,
    y: 32.24,
    width: 96.01,
    height: 96.01,
    rx: 13.72,
    ry: 13.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M213.73,128.25h-68.58c-7.56,0-13.72-6.15-13.72-13.72V45.95c0-7.56,6.15-13.72,13.72-13.72h68.58c7.56,0,13.72,6.15,13.72,13.72V114.54c0,7.56-6.15,13.72-13.72,13.72ZM145.14,39.1c-3.78,0-6.86,3.08-6.86,6.86V114.54c0,3.78,3.07,6.86,6.86,6.86h68.58c3.78,0,6.86-3.08,6.86-6.86V45.95c0-3.78-3.07-6.86-6.86-6.86h-68.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M179.44,135.11h0c26.51,0,48.01,21.49,48.01,48.01h0c0,26.51-21.49,48.01-48.01,48.01h0c-26.51,0-48.01-21.49-48.01-48.01h0c0-26.51,21.49-48.01,48.01-48.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M179.44,231.12c-26.47,0-48.01-21.54-48.01-48.01s21.54-48,48.01-48,48.01,21.54,48.01,48-21.54,48.01-48.01,48.01Zm0-89.15c-22.69,0-41.15,18.45-41.15,41.15s18.46,41.15,41.15,41.15,41.15-18.46,41.15-41.15-18.46-41.15-41.15-41.15Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 28.56,
    y: 135.11,
    width: 96.01,
    height: 96.01,
    rx: 13.72,
    ry: 13.72
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M110.85,231.12H42.27c-7.56,0-13.72-6.15-13.72-13.72v-68.58c0-7.56,6.15-13.72,13.72-13.72H110.85c7.56,0,13.72,6.15,13.72,13.72v68.58c0,7.56-6.15,13.72-13.72,13.72ZM42.27,141.97c-3.78,0-6.86,3.08-6.86,6.86v68.58c0,3.78,3.07,6.86,6.86,6.86H110.85c3.78,0,6.86-3.07,6.86-6.86v-68.58c0-3.78-3.07-6.86-6.86-6.86H42.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomnavMore);
export default __webpack_public_path__ + "static/media/bottomnav-more.75d91c888a15ee31f545f76723ab46ce.svg";
export { ForwardRef as ReactComponent };